export enum ProfileSections {
  PERSONAL_DATA = "personal-data",
  ACTIVITY = "activity",
  HOUSEHOLD = "household",
  INCOME = "income",
  ASSETS = "assets",
  ISEE = "isee",
  LIVING_SITUATION = "living-situation",
}
